const NonOrgEntity = (props) => {
  const entityProperties = props.ent.prop_string ? " " + props.ent.prop_string : null;
  return (
    <span><a href={props.ent.edit_link} target="_blank">{props.ent.name}</a>{entityProperties}; </span>
  );
};

export default NonOrgEntity;
